import {
	type BlokProps,
	StoryblokComponent,
	StoryblokComponentList,
} from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokPage } from "@/storyblok";
import type { AllBloks } from "../defineBloks";
import styles from "./PageBlok.module.css";

export const PageBlok = ({ blok, preview }: BlokProps<BlokPage>) => {
	return (
		<BlokWrap asChild editable={blok}>
			<main className={styles.root}>
				{blok.header && (
					<StoryblokComponentList
						bloks={blok.header as AllBloks[]}
						preview={preview}
					/>
				)}
				<div className={styles.body}>
					{blok.body?.map((blok, index) => {
						return (
							<StoryblokComponent
								key={(blok as AllBloks)._uid}
								blok={blok as AllBloks}
								data-blok-index={index}
								data-priority={index <= 0}
								preview={preview}
							/>
						);
					})}
				</div>
			</main>
		</BlokWrap>
	);
};
